'use strict';

angular.module('adelementAdminApp')
    .factory('Modulepermissions', function ($resource, DateUtils) {
        return $resource('api/modulepermissionss/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });
